import { render } from "./CategoryLoader.vue?vue&type=template&id=7e807b81"
import script from "./CategoryLoader.vue?vue&type=script&lang=js"
export * from "./CategoryLoader.vue?vue&type=script&lang=js"

import "./CategoryLoader.vue?vue&type=style&index=0&id=7e807b81&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__